import { PlansPlanMode } from '../../../api/types'
import {
  isListPlansFetchFailed,
  isListPlansLoading,
  useLumpsumPlansContext
} from '../../LumpsumPlansProvider'
import { PlansCategoryListSkeleton } from '../../lumpsum-ui-components/PlansCategoryListSkeleton'
import { RebalanceBlurredBody } from './RebalanceBlurredBody'
import { RebalanceCategoryList } from './RebalanceCategoryList'
import { RebalancePlansListErrorState } from './RebalancePlansListErrorState'

/** Rolled-out rebalance body: locked (not Elite) or full list. */
export function LumpsumRebalanceBody() {
  const { rebalancePlansData, rebalancePlansQuery } = useLumpsumPlansContext()

  if (isListPlansLoading(PlansPlanMode.REBALANCE, rebalancePlansQuery)) {
    return <PlansCategoryListSkeleton />
  }

  if (isListPlansFetchFailed(PlansPlanMode.REBALANCE, rebalancePlansQuery)) {
    return <RebalancePlansListErrorState onRetry={rebalancePlansQuery.refetch} />
  }

  if (rebalancePlansData?.isPlanSubscriptionEligible !== true) {
    return <RebalanceBlurredBody />
  }

  return <RebalanceCategoryList />
}
